export const REPATHING_CURVE_Y = 0.062;
export const REPATHING_SOURCE_Y = 0.03;
export const REPATHING_CONTROL_Y = 0.085;
export const REPATHING_HANDLE_Y = 0.095;
/** Draw after grid/ground; depth testing lets actor meshes occlude Repathing visuals. */
export const REPATHING_RENDER_ORDER = 10;
export const REPATHING_CURVE_LINE_WIDTH = 0.004125;
export const REPATHING_SOURCE_LINE_WIDTH = 0.0042;
export const REPATHING_HANDLE_LINE_WIDTH = 1;
export const REPATHING_INSERT_MIN_U_GAP = 0.004;
export const REPATHING_MIN_CONTROLS = 6;
export const REPATHING_MAX_CONTROLS = 36;
export const REPATHING_EVAL_STEPS = 220;
export const REPATHING_DEFAULT_BRUSH_RADIUS = 0.45;
export const REPATHING_DEFAULT_BRUSH_STRENGTH = 0.65;
export const REPATHING_BRUSH_RADIUS_MIN = 0.1;
export const REPATHING_BRUSH_RADIUS_MAX = 2.5;
export const REPATHING_BRUSH_STRENGTH_MIN = 0.05;
export const REPATHING_BRUSH_STRENGTH_MAX = 1;

export const REPATHING_COLORS = {
  source: '#ffffff',
  curve: '#3ad676',
  selected: '#1478ff',
  endpoint: '#f2c94c',
  endpointActive: '#d9ad3f',
  control: '#3ad676',
  controlActive: '#2fc263',
  handle: '#505050',
  handleActive: '#222222',
  handleLine: '#ffffff',
} as const;
